export const LanguagesInSeattle = [
  {
    heading: "Russian",
    detail:
      "Seattle's huge Russian communities are a valuable resource. Why not reach this demographic by utilizing translation within Seattle? The key to your business success may lie in Russian to English translation and English to Russian translation service. Reach out now.",
    link: "/russian-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "A majority language in Seattle, Chinese is also a major language in the business world. Chinese may be important for your business transactions, and Tomedes has you covered with Chinese translation services. Get started today.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Vietnamese",
    detail:
      "Vietnamese is spoken in the home by a majority of residents in this city. Vietnamese translation services also have applications for businesses who want to expand their operations outside of Seattle, since Vietnames is also a major language in the world. Contact us.",
    link: "/vietnamese-translation.php",
  },
  {
    heading: "German",
    detail:
      "German is a major European language and a major language for communities in this city as well. Bridge the language gap within these communities with Tomedes' translation services in Seattle, WA. If you're interested in more, get in touch now.",
    link: "/german-translation.php",
  },
];
